import { Construction, Mail, Phone, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_escape-nexus/artifacts/6l2bsu58_key-2-final-escaped%20%281%29.png';

export default function UnderConstructionPage() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-10"
          style={{ background: 'radial-gradient(circle, #E32510 0%, transparent 70%)' }}
        />
      </div>

      <div className="relative z-10 text-center max-w-lg">
        <div className="relative inline-block">
          <img src={LOGO_URL} alt="OKI-ESCAPE" className="h-24 sm:h-32 mx-auto mb-8 object-contain" />
          <Link
            to="/admin/login"
            data-testid="construction-admin-link"
            title="Admin"
            className="absolute -right-5 top-0 w-8 h-8 rounded-full bg-neutral-800/60 flex items-center justify-center hover:bg-brand/20 hover:text-brand transition-colors text-neutral-600"
          >
            <Lock size={14} />
          </Link>
        </div>

        <div className="inline-flex items-center gap-2 text-brand font-heading text-xs tracking-[0.25em] uppercase mb-4">
          <Construction size={16} />
          <span>Under Construction</span>
        </div>

        <h1
          data-testid="construction-heading"
          className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-wide uppercase mb-4"
          style={{ textShadow: '0 0 40px rgba(227,37,16,0.25)' }}
        >
          We'll Be Back Soon
        </h1>

        <p className="font-sans text-base sm:text-lg text-neutral-400 mb-8 leading-relaxed">
          We're making some exciting changes to OKI-ESCAPE. Our escape rooms are still open for bookings — contact us directly!
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://book.squareup.com/appointments/h2vlbju85siksv/location/L7GDDBBGP4SJJ/services"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="construction-book-btn"
            className="font-heading text-sm tracking-widest uppercase bg-brand text-white px-8 py-4 rounded-full hover:bg-brand-hover transition-colors neon-glow"
          >
            Book Now
          </a>
          <a
            href="http://facebook.com/okiescape"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="construction-facebook-btn"
            className="font-heading text-sm tracking-widest uppercase border-2 border-neutral-700 text-neutral-300 px-8 py-4 rounded-full hover:border-brand hover:text-brand transition-colors"
          >
            Message Us
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-neutral-500">
          <a href="mailto:info@okiescape.com" className="inline-flex items-center gap-2 font-sans text-sm hover:text-brand transition-colors">
            <Mail size={14} /> info@okiescape.com
          </a>
          <a href="tel:098-989-0319" className="inline-flex items-center gap-2 font-sans text-sm hover:text-brand transition-colors">
            <Phone size={14} /> 098-989-0319
          </a>
        </div>
      </div>
    </div>
  );
}
